import { Component, SimpleChanges, OnChanges, Input, Output, EventEmitter } from '@angular/core';

import { CartServiceV2 } from '../../../cart/services/cart-v2.service';
import { ngHelper } from '@cakeiteasy/web-utils';
import { ICart, IAppliedDiscount, DISCOUNT_TYPES } from '../../../cart';
import { CART_PROMO_CODE_TYPES } from '../../constants/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'mobile-promo-code-section',
  templateUrl: './mobile-promo-code-section.component.html',
  styleUrls: ['./mobile-promo-code-section.component.scss']
})
export class MobilePromoCodeSectionComponent implements OnChanges {
  @Input() cart: ICart;
  @Input() currency: string;
  @Input() applyDiscountFor: CART_PROMO_CODE_TYPES;
  @Input() errorMsg = '';

  @Output() onPromoCodeApplied = new EventEmitter<CART_PROMO_CODE_TYPES>();

  public newDiscountCode: string;
  public isPromoCollapsed: boolean;
  public busy: Promise<any>;
  public appliedDiscount: IAppliedDiscount = null;

  public get isApplyDiscountEnabled() {
    return !this.appliedDiscount || this.appliedDiscount.type !== DISCOUNT_TYPES.BAKERY_DISCOUNT
      && this.appliedDiscount.type !== DISCOUNT_TYPES.PROMO_CODE;
  }

  constructor(protected _cartService: CartServiceV2,
              protected _translate: TranslateService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'cart', (cart: ICart) => {
      if (!cart) {
        return;
      }

      this.appliedDiscount = cart.appliedDiscount || null;
      this.isPromoCollapsed = !this.appliedDiscount
        || this.appliedDiscount.type !== DISCOUNT_TYPES.BAKERY_DISCOUNT && this.appliedDiscount.type !== DISCOUNT_TYPES.PROMO_CODE;
    });

    ngHelper.ifChanged(changes, 'errorMsg', (errorMsg: string) => {
      if (!errorMsg) {
        return;
      }

      this.isPromoCollapsed = false;
    });
  }

  public async applyPromo(code) {
    this.errorMsg = '';
    const { STORE, BAKERY } = CART_PROMO_CODE_TYPES;

    try {
      if (this.applyDiscountFor === STORE) {
        await (this.busy = this._cartService.applyDiscount(code, this.cart.bakery.country.code));
        this.onPromoCodeApplied.emit(STORE);
      } else if (this.applyDiscountFor === BAKERY) {
        await (this.busy = this._cartService.applyBakeryDiscount(code));
        this.onPromoCodeApplied.emit(BAKERY);
      }
    } catch (e) {
      this.errorMsg = this._translate.instant('orderProcess.payment.promoCodeSection.error');
    }
  }
}
